export default{
    CLEAR_LIST : "clearList",
    DELETE_DIARY : "deleteDiary",
    REVISE_DIARY : "reviseDiary"
}